import { smoothScroll } from '../utils/scroll';
import { lenis } from './animations';

export const initSmoothScroll = () => {
  const scrollOffset = 60;

  function triggerBackToTop() {
    const backToTopButton = document.querySelector('.js-b2t');

    if (!backToTopButton) return;

    backToTopButton.addEventListener("click", () => {
      smoothScroll();
    });
  }

  function anchorScroll() {
    const excludeIds = ['#modal-login'];

    document.querySelectorAll('a[href*="#"]').forEach(anchor => {
      anchor.addEventListener('click', (e) => {
        const href = anchor.getAttribute('href');
        const url = new URL(href, window.location.href);

        const togglerMobileMenu = document.querySelector('.navbar-toggler.close-menu');
        const mobileMenu = document.querySelector('.header__nav-mobile.open-mobile-menu');

        if(mobileMenu && togglerMobileMenu) {
          mobileMenu.classList.remove('open-mobile-menu');
          togglerMobileMenu.classList.remove('close-menu');
          lenis.start();
        }

        if (url.pathname === window.location.pathname) {
          e.preventDefault();
          const anchorId = url.hash;

          if (excludeIds.includes(anchorId)) {
            return;
          }

          if (anchorId) {
            smoothScroll(anchorId, scrollOffset);
          }
        }
      });
    });
  }

  function handleHashScroll() {
    const hash = window.location.hash;

    if (hash) {
      window.scrollTo(0, 0);

      const target = document.querySelector(hash);

      if (target) {
        smoothScroll(target, scrollOffset)
      }
    }
  }

  return {
    init() {
      triggerBackToTop();
      anchorScroll();
      handleHashScroll();
    },
  }
}
